import { DimensionStatus, InsightPriority } from "types/graphql-schema";

export type Status = DimensionStatus;
export type Priority = InsightPriority;

export const statusDot: Record<Status, string> = {
  good: "bg-emerald-500",
  warn: "bg-amber-400",
  alert: "bg-orange-500",
  critical: "bg-red-500",
};

export const statusBadge: Record<Status, string> = {
  good: "bg-emerald-50 text-emerald-700 ring-emerald-600/20",
  warn: "bg-amber-50 text-amber-700 ring-amber-600/20",
  alert: "bg-orange-50 text-orange-700 ring-orange-600/20",
  critical: "bg-red-50 text-red-700 ring-red-600/20",
};

export const priorityBadge: Record<
  Priority,
  { status: Status; label: string }
> = {
  high: { status: DimensionStatus.Critical, label: "Needs Attention" },
  medium: { status: DimensionStatus.Alert, label: "Monitor" },
  low: { status: DimensionStatus.Warn, label: "Low Priority" },
  positive: { status: DimensionStatus.Good, label: "Doing Well" },
};

export const sourceTypeLabel: Record<string, string> = {
  meeting: "Meeting",
  goal: "Goal",
  recognition: "Recognition",
  checkin: "Check-in",
  work_summary: "Work Summary",
};

export const sourceTypeDot: Record<string, string> = {
  meeting: "bg-blue-400",
  goal: "bg-emerald-400",
  recognition: "bg-amber-400",
  checkin: "bg-purple-400",
  work_summary: "bg-gray-400",
};
